import React, { useState } from 'react';
import {
  Row,
  Col,
  Card,
  Typography,
  Button,
  Tooltip,
  Modal,
  Empty,
  Space,
} from 'antd';
import {
  DeleteOutlined,
} from '@ant-design/icons';
import styled from 'styled-components';

const ImagePreview = styled.div`
  width: 100%;
  height: 250px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
  cursor: pointer;
  transition: all 0.3s;
  
  &:hover {
    opacity: 0.8;
  }
`;

const StyledImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
`;

function ImageList({
  images = [], deleteImage, loading,
}) {
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');
  const handlePreview = (item) => {
    setPreviewImage(item.url);
    setPreviewTitle({
      title: item.name || 'Изображение',
    }.title);
    setPreviewVisible(true);
  };

  const handleCancel = () => setPreviewVisible(false);

  return (
    <div>

      {images.length === 0 ? (
        <Empty
          description="Нет загруженных изображений"
          image={Empty.PRESENTED_IMAGE_SIMPLE}
        />
      ) : (
        <Row gutter={[24, 24]}>
          {images.map((item) => (
            <Col key={item.id} xs={24} sm={24} md={12} lg={12}>
              <Card
                size="small"
                title={(
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '100%',
                    alignItems: 'center',
                  }}
                  >
                    <Tooltip title={item.name} placement="topLeft">
                      <Typography.Text
                        style={{
                          fontSize: '18px',
                          flex: 1,
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          cursor: 'default',
                        }}
                      >
                        {item.name}
                      </Typography.Text>
                    </Tooltip>
                    <Space size="middle">
                      <Tooltip title="Удалить изображение">
                        <Button
                          danger
                          icon={<DeleteOutlined />}
                          onClick={() => deleteImage(item.id)}
                          disabled={loading}
                        />
                      </Tooltip>
                    </Space>
                  </div>
                )}
                headStyle={{
                  padding: '10px 10px',
                }}
                extra={null}
                bodyStyle={{ padding: 0 }}
              >
                <ImagePreview onClick={() => handlePreview(item)}>
                  <StyledImage
                    alt={item.name}
                    src={item.url}
                  />
                </ImagePreview>
              </Card>
            </Col>
          ))}
        </Row>
      )}

      <Modal
        visible={previewVisible}
        title={previewTitle}
        footer={null}
        onCancel={handleCancel}
        width="80%"
        centered
      >
        <img
          alt={previewTitle}
          style={{ width: '100%' }}
          src={previewImage}
        />
      </Modal>
    </div>
  );
}

export default ImageList;
